<template>
  <div
    class="content-datepicker eu-zindex_4 eu-position_relative"
    id="datepicker"
  >
    <input-date
      aria-autocomplete="off"
      :class="classList"
      :id="id"
      :locale="locale"
      :value="dateModel"
    />
  </div>
</template>
<script>
import InputDate from './InputDate'
import { Datepicker } from 'vanillajs-datepicker'
import * as pt from 'vanillajs-datepicker/js/i18n/locales/pt-BR.js'

export default {
  name: 'Datepicker',
  components: {
    InputDate
  },
  props: {
    id: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    classList: {
      type: Array,
      required: false
    },
    locale: {
      type: String,
      required: false,
      default: 'pt-BR'
    },
    minDate: {
      type: Date,
      default: null
    }
  },
  data () {
    return {
      datepicker: {},
      selectedDate: {},
      format: this.locale === 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy',
      dateModel: this.date
    }
  },
  watch: {
    date (value) {
      this.dateModel = value
    }
  },
  methods: {
    validateDate (input) {
      const classError = input.classList.contains('_state_error')
      if (
        this.selectedDate.value === null ||
        this.selectedDate.value === undefined ||
        this.selectedDate.value === ''
      ) {
        input.classList.remove('_state_error')
      } else if (this.selectedDate.value.length === 10) {
        const date = new Date(this.selectedDate.value)
        if (isNaN(date.getTime()) || date.getTime() < 0) {
          if (!classError) input.classList.add('_state_error')
        } else {
          input.classList.remove('_state_error')
        }
      } else {
        if (!classError) input.classList.add('_state_error')
      }
    }
  },
  mounted () {
    const input = document.getElementById(this.id)
    Object.assign(Datepicker.locales, pt.default)
    this.datepicker = new Datepicker(input, {
      showOnFocus: true,
      autohide: true,
      language: this.locale === 'en-US' ? 'en' : 'pt-BR',
      format: this.format,
      container: '#datepicker',
      orientation: 'left bottom',
      maxDate: new Date(),
      minDate: this.minDate
    })
    input.addEventListener('changeDate', event => {
      if (this.datepicker.getDate('dd/mm/yyyy')) {
        this.selectedDate = {
          value: this.datepicker
            .getDate('dd/mm/yyyy')
            .split('/')
            .reverse()
            .join('-'),
          text: this.datepicker.getDate(this.format)
        }
        this.validateDate(input)
        if (!input.classList.contains('_state_error')) {
          this.$emit('changeDate', this.selectedDate)
        }
      }
    })
    input.addEventListener('click', () => {
      this.datepicker.show()
    })
    input.addEventListener('input', event => {
      this.datepicker.hide()
      if (event.target.value.length === 10) {
        this.datepicker.setDate(event.target.value, { format: this.format })
      }
    })
  }
}
</script>
